<script setup lang="ts">
definePageMeta({
  layout: 'landing',
  smoothScroll: true,
})

const { t } = useI18n()

const { crumbs } = useBreadcrumbs([
  { label: t('label.home'), to: '/' },
  { label: t('page.privacy_policy.title') },
])

useHead({
  titleTemplate: (chunk) => chunk || 'bookforme',
  title: () => `bookforme — ${t('page.privacy_policy.title')}`,
  meta: [
    { name: 'description', content: 'Read the bookforme Privacy Policy to understand how we collect, use, and protect your personal data.' },
    { property: 'og:type', content: 'website' },
    { property: 'og:title', content: () => `bookforme — ${t('page.privacy_policy.title')}` },
    { property: 'og:site_name', content: 'bookforme' },
    { name: 'twitter:card', content: 'summary_large_image' },
  ],
})
</script>

<template>
  <div>
    <CommonBreadcrumbs :items="crumbs" />

    <LandingPrivacyPolicyHero />
    <LandingPrivacyPolicyContent />
  </div>
</template>
